import type { Offer } from '@tixa/schema'

import { Storage } from '~/utils'

const STORAGE_ID = 'pendingOrderData'

const PAYMENT_INITIATED_CART_KEY = 'paymentInitiatedCartId'

export type StoredOrderData = {
  orderId: string
  cartId: string
  event: string
  offers: Offer[]
  name: string
  city: string
  zip: string
  email: string
  phone: string
}

const useOrderStore = () => {
  const storeOrderData = async (data: StoredOrderData) => {
    const trackedOffers = data.offers.filter(
      (item) =>
        item.eligibleQuantity.value > 0 &&
        !item['@id'].toString().startsWith('-')
    )
    await Storage.storeAsync(
      STORAGE_ID,
      JSON.stringify({
        ...data,
        offers: trackedOffers,
      })
    )
  }

  const hasOrderData = async () => {
    return await Storage.hasInStoreAsync(STORAGE_ID)
  }

  const getOrderData = async () => {
    const data = await Storage.getFromStoreAsync(STORAGE_ID)
    return JSON.parse(data) as StoredOrderData
  }

  const clear = async () => {
    await Storage.removeFromStoreAsync(STORAGE_ID)
    Storage.removeFromStore(PAYMENT_INITIATED_CART_KEY)
  }

  return {
    clear,
    hasOrderData,
    storeOrderData,
    getOrderData,
  }
}

export function markPaymentInitiatedForCartSync(cartId: string | number): void {
  Storage.store(PAYMENT_INITIATED_CART_KEY, String(cartId))
}

export function clearPaymentInitiatedForCartSync(): void {
  Storage.removeFromStore(PAYMENT_INITIATED_CART_KEY)
}

export function isPaymentInitiatedForCartSync(
  cartId: string | number | undefined
): boolean {
  if (cartId === undefined || cartId === null) {
    return false
  }
  const stored = Storage.getFromStore(PAYMENT_INITIATED_CART_KEY)
  return stored !== '' && stored === String(cartId)
}

export { useOrderStore }
